export default __webpack_public_path__ + "static/media/IoTIcon.44e3183f.svg";